import { macroSettings, macroParameters } from './shared.js';

export default {
  label: 'Chromatic Focal Shift', group: 'performance',
  description: 'Paraxial focus shift, and best-focus shift of the field 1 wavefront, against wavelength.',
  settingsSchema: macroSettings,
  parameters: macroParameters,
  coverage: 'The band runs from the shortest to the longest wavelength with nonzero weight; zero-weight wavelengths outside it are ignored. The plot needs Listing set to Yes.',
} as const;
